import React, { useState } from "react";
import Layout from '../Components/Layout/Layout'
import SubHome from '../Components/Sub_Home/SubHome'

const HomePage = () => {
  const [cartItems, setCartItems] = useState([]);

  return (
    <Layout setCartItems={setCartItems} cartItems={cartItems} isFooter={true} isNavbar={true}> 
      <SubHome/>
    </Layout>
  )
}

export default HomePage